exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".posmaliyet-report-table[data-v-cb434c70]{width:100%;margin-top:4px}.posmaliyet-report-table>*[data-v-cb434c70]{width:100%}", ""]);

// exports
